import BaseService from '@root/core/class/BaseService';

interface IPagination {
  page: number;
  fromDt?: string;
  toDt?: string;
  state?: string;
  filter?: string;
  input?: string;
}
class inquiryService extends BaseService {
  public getListInquiry = () => {
    return this.get('/quotations');
  };

  public postDownExcel = (
    fromDt?: string,
    toDt?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean
  ) => {
    // return this.post('/quotations/export', {
    //   responseType: 'blob'
    // });
    return this.post(
      `/quotations/export?${
        Boolean(searchBy) ? '&searchBy=' + searchBy : '&searchBy='
      }${Boolean(input) ? '&search=' + input : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public postDownExcelId = (body: Record<string, any>) => {
    return this.post('/quotations/export', body, {
      responseType: 'blob'
    });
  };
  public getDetailInquiry = (inquiryWareId: number) => {
    return this.get(`/quotations/${inquiryWareId}`);
  };
  public getListComment = (inquiryWareId: number) => {
    return this.get(`/quotations/${inquiryWareId}/comments`);
  };
  public postReject = (inquiryWareId: number) => {
    return this.post(`/quotations/${inquiryWareId}/reject`);
  };
  public postApprove = (inquiryWareId: number) => {
    return this.post(`/quotations/${inquiryWareId}/approve`);
  };
  public getPagingWare = (page: any, limit: any) => {
    return this.get(`/quotations?page=${page}&limit=${limit}`);
  };
  public postCommentWare = (
    inquiryWareId: string,
    body: Record<string, any>
  ) => {
    return this.post(`/quotations/${inquiryWareId}/comments`, body);
  };
  public putCommentWare = (
    inquiryWareId: string,
    idComment: any,
    body: Record<string, any>
  ) => {
    return this.put(`/quotations/${inquiryWareId}/comments/${idComment}`, body);
  };
  public postUploadImg = (body: Record<string, any>) => {
    return this.post('/quotations/uploadFiles', body);
  };

  public getPagination = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    return this.get(
      `/quotations?page=${page}&limit=10${
        Boolean(searchBy) ? '&filterBy=' + searchBy : '&filterBy='
      }${Boolean(state) ? '&searchBy=' + state : '&searchBy='}${
        Boolean(inputUse) ? '&search=' + inputUse : '&search='
      }${Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='}${
        Boolean(toDt) ? '&toDt=' + toDt : '&toDt='
      }${Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };
}
export default new inquiryService('/api/v1/warehouse', true);
